export default __webpack_public_path__ + "static/media/door.765e3968.fbx";